/*
 * @description: 动态路由 方法
 * @Author: Jay
 * @Date: 2023-09-05 09:26:12
 * @LastEditors: Jay
 * @LastEditTime: 2026-08-10 15:05:22
 */
import store from '@/store'
import router from "@/router/index"

// 本地存储-操作
import { sessionStorage } from "@/utils/localstorage"

/** 
 * 主菜单-静态地址
 *   当前以改为线上获取
 *  */
// import { mainMenu } from './mainMenu-modules/mainMenu'
//模拟动态路由数据
// import menuDate from "./mainMenu-modules/TextMenuData.js";

//第一次进入 设置路由
sessionStorage.set('storageAside', '0')

//添加路由
export const setRoutes = async () => {
    //身份 0则是商户 1是代理
    let rankType = String(sessionStorage.get('saveRankType'))
    console.warn('当前身份', rankType);
    //是否第一次进入 设置路由
    let storageAside = String(sessionStorage.get('storageAside'))
    // console.warn('是否进入-设置路由', storageAside);

    // 获取路由缓存列表
    let routeCacheList = sessionStorage.get('createRoutes')
    // console.log('获取路由缓存列表', routeCacheList);

    // 身份不等于 null 第一次加载路由
    if (rankType != null && storageAside === '0') {

        sessionStorage.set('storageAside', '1')

        //代理路由添加
        if (rankType == '1') {
            console.warn('代理添加router')
            routeCacheList.map((item) => {
                //每一个路由都添加进去
                router.options.routes.push(item)
                router.addRoute(item)
            })
        }

        //商户路由添加
        if (rankType == '0') {
            console.warn('商户添加router')
            //处理线上路由
            disposeRoute(routeCacheList)
        }
    }
}

//处理线上路由
export const disposeRoute = (routeCacheList) => {
    // 用户权限获取
    let rolesPower = sessionStorage.get('rolesPower')
    // console.log('用户权限获取', rolesPower)

    //动态路由请求
    let dynamicData = filterAsyncRouter(routeCacheList)
    // console.log('路由异步添加', dynamicData)

    // 权限处理
    store.dispatch('permission/generateRoutes', {
        roles: rolesPower,
        routes: dynamicData
    }).then((res) => {
        // console.warn('vuex处理', res)
        res.map((item) => {
            //每一个路由都添加进去
            router.options.routes.push(item)
            router.addRoute(item)
        })
    })
    // console.log("当前路由", router.getRoutes());
    // console.log("当前路由", router.getRoutes().length);
}

// 路由页面地址 拼接
export const loadView = (view) => {
    return (resolve) => require([`@/views/${view}.vue`], resolve)
}

//路由异步添加
export const filterAsyncRouter = (routeList) => {
    return routeList.filter((route) => {
        if (route.component) {
            // 如果不是布局组件就只能是页面的引用了
            // 利用懒加载函数将实际页面赋值给它
            route.component = loadView(route.component)
            // 判断是否存在子路由，并递归调用自己
            if (route.children && route.children.length) {
                route.children = filterAsyncRouter(route.children)
            }
            return true
        }
    })
}

//转化为路由表格式
// export const generateRouter = (UserRouter) => {
//     let newRouters = UserRouter.map((r) => {
//         let routes = {
//             path: r.path,
//             name: r?.name,
//             redirect: r?.redirect,
//             meta: r?.meta,
//             component: () => loadView(r.name)//利用字符串模板拼接
//         }
//         if (r.children) {//如果该结点有孩子，则继续递归
//             routes.children = generateRouter(r.children)
//         }
//         return routes
//     })
//     return newRouters
// }